import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const ChevronDownIcon = (props?: SvgProps) => (
  <svg
    height="24"
    width="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <path
      d="M6 9L12 15L18 9"
      stroke="#B0B2B6"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
)
